import addDirectory from './AddDirectory';

const authznReducers = () => ({
  addDirectory
});

export default authznReducers;
